import React from 'react';
import { withStyles } from '@material-ui/styles';

import { BlogPost } from 'components';

import useBlogPosts from './useBlogPosts';
import styles from './style';

interface Props {
  classes: any;
};

const BlogPostList = ({ classes }: Props) => {
  const portfolio = useBlogPosts();

  return (
    <div className={classes.container}>
      {portfolio.allFile.nodes.map((portfolioNode, index) => (
        <BlogPost key={index} data={portfolioNode} />
      ))}
    </div>
  );
};

export default withStyles(styles)(BlogPostList);
